﻿'use strict';

/**
* Working with input number
*
* @example 
*/

angular.module('ntmApp')
  .directive('numberSpinner', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/directives/templates/numberspinner.html',
          scope: {
              disabled: '=',
              number: '=',
              max: '=',
              min: '=',
              step: '=',
              roundTo: '=',
              required: '=',
              withDot: '=',
              onChange: '&',
              inputName: '@'
          },
          link: function (scope, element) {
              var BackSpaceEventCode = 8;
              var DotEnteredEventCode = 46;
              var MinusSignEnteredEventCode = 45;
              var NumberEnteredLowerLimitEventCode = 48;
              var NumberEnteredUpperLimitEventCode = 57;

              var MAX_NUMBER_LENGTH_LIMIT = 5;

              var ZERO_SYMBOL = '0';
              var MINUS_SYMBOL = '-';
              var DOT_SYMBOL = '.';

              scope.steupUp = function () {

                  var value = parseFloat(scope.editingNumber || 0);
                  var nextValue = Math.floor(value / scope.step) * scope.step + scope.step;

                  if (value === nextValue) {
                      nextValue += scope.step;
                  }

                  if(!angular.isNumber(scope.max) || scope.max >= nextValue) { 
                      scope.number = nextValue;

                      if (!$rootScope.$$phase && !scope.$$phase) {
                          scope.$apply();
                      }

                      $timeout(function () {

                          if (scope.onChange) {
                              scope.onChange();
                          }

                      }, 0);
                  }
                  
              };

              scope.stepDown = function () {

                  var value = parseFloat(scope.editingNumber || 0);
                  var nextValue = Math.floor(value / scope.step) * scope.step;

                  if (value === nextValue) {
                      nextValue -= scope.step;
                  }

                  if (!angular.isNumber(scope.min) || scope.min <= nextValue) {
                      scope.number = nextValue;

                      if (!$rootScope.$$phase && !scope.$$phase) {
                          scope.$apply();
                      }

                      $timeout(function () {

                          if (scope.onChange) {
                              scope.onChange();
                          }

                      }, 0);
                  }
              };

              scope.isValid = function () {
                  if (scope.required) {
                      return !isNaN(scope.number) &&
                             scope.number !== null &&
                             !angular.isUndefined(scope.number) &&
                             scope.number !== '';
                  }

                  return true;
              };

              $(element).find(':text').bind('keyup', function () {

                  var editingNumber = parseFloat(angular.copy(scope.editingNumber));

                  if (scope.number !== editingNumber) {
                      scope.number = editingNumber;

                      if (!$rootScope.$$phase && !scope.$$phase) {
                          scope.$apply();
                      }

                      $timeout(function () {

                          if (scope.onChange) {
                              scope.onChange();
                          }

                      }, 0);
                  }

              });

              $(element).find(':text').bind('keypress', function (event) {

                  var element = $(this);

                  var deniedByNumberInputRules = dotDenied(event, element) || 
                                                 minsSignDenied(event, element) || 
                                                 nonNumberEntered(event) || 
                                                 numberAfterDotDenied(element) || 
                                                 tooLargeNumberDenied(event, element) || 
                                                 symbolDeniedIfZeroIsFirst(event, element) || 
                                                 isNumberGreaterThanMax(event, element) ||
                                                 isNumberLessThanMin(event, element);

                  if (deniedByNumberInputRules && event.which !== BackSpaceEventCode && event.which !== 0) {
                      event.preventDefault();
                  }
              });


              function nonNumberEntered(event) {
                  
                  if (event.which === DotEnteredEventCode || event.which === MinusSignEnteredEventCode) {
                      return false;
                  }

                  return event.which < NumberEnteredLowerLimitEventCode || event.which > NumberEnteredUpperLimitEventCode;
              }

              function dotDenied(event, element) {

                  var inputValue = gettextWithoutSelection(element);

                  if (event.which === DotEnteredEventCode) {
                      if (scope.withDot) {
                          return inputValue.indexOf(DOT_SYMBOL) !== -1 || inputValue === '' || inputValue === MINUS_SYMBOL;
                      } else {
                          return true;
                      }
                  }

                  return false;
              }

              function minsSignDenied(event, element) {

                  if (event.which === MinusSignEnteredEventCode) {

                      if (angular.isNumber(scope.min) && scope.min >= 0) {
                          return true;
                      }

                      var text = gettextWithoutSelection(element);

                      return (text !== '' && getCursorPosition(element) > 0) || text.indexOf(MINUS_SYMBOL) !== -1 || text === DOT_SYMBOL;
                  }

                  return false;
              }

              function numberAfterDotDenied(element) {
                  var inputValue = gettextWithoutSelection(element);
                  var indexOfDot = inputValue.indexOf(DOT_SYMBOL);

                  if (indexOfDot !== -1) {
                      var cursorPosition = getCursorPosition(element);

                      if (cursorPosition > indexOfDot) {
                            
                          var decimalsEntered = inputValue.split(DOT_SYMBOL)[1];

                          if (decimalsEntered && decimalsEntered.length >= parseInt(scope.roundTo)) {
                              return true;
                          }
                      }
                  }

                  return false;
              }

              function tooLargeNumberDenied(event, element) {

                  if (event.which === DotEnteredEventCode || event.which === MinusSignEnteredEventCode) {
                      return false;
                  }

                  var inputValue = gettextWithoutSelection(element);
                  var indexOfDot = inputValue.indexOf(DOT_SYMBOL);

                  if (indexOfDot !== -1) {

                      var cursorPosition = getCursorPosition(element);

                      if (cursorPosition <= indexOfDot) {

                          var numberText = inputValue.split(DOT_SYMBOL)[0];
                          var numberTextLength = numberText.indexOf(MINUS_SYMBOL) === -1 ? numberText.length + 1 : numberText.length;
                          return numberTextLength > MAX_NUMBER_LENGTH_LIMIT;
                      } else {
                          return false;
                      }
                  }

                  var textLength = inputValue.indexOf(MINUS_SYMBOL) === -1 ? inputValue.length + 1 : inputValue.length;
                  return textLength > MAX_NUMBER_LENGTH_LIMIT;
              }

              function symbolDeniedIfZeroIsFirst(event, element) {

                  var inputValue = gettextWithoutSelection(element);
                  
                  if (inputValue && (inputValue[0] === ZERO_SYMBOL || (inputValue.length >= 2 && inputValue[0] === MINUS_SYMBOL && inputValue[1] === ZERO_SYMBOL))) {
                      var cursorPosition = getCursorPosition(element);

                      if (cursorPosition > 0) {

                          if (scope.withDot) {
                              var indexOfDot = inputValue.indexOf(DOT_SYMBOL);
                              var allowedDotPosition = inputValue[0] === MINUS_SYMBOL ? 2 : 1;


                              if (indexOfDot === allowedDotPosition && cursorPosition > allowedDotPosition) {
                                  return false;
                              } else {
                                  return event.which !== DotEnteredEventCode;
                              }

                          } else {
                              return true;
                          }
                      }
                  }

                  return false;

              }

              function isNumberGreaterThanMax(event, element) {
                  var inputValue = gettextWithoutSelection(element);
                  var insertingPosition = getCursorPosition(element);
                  var eneteredValue = String.fromCharCode(event.which);

                  var result = inputValue.substring(0, insertingPosition) + eneteredValue + inputValue.substring(insertingPosition, inputValue.length);
                  return angular.isNumber(scope.max) && parseFloat(result) > scope.max;
              }

              function isNumberLessThanMin(event, element) {
                  var inputValue = gettextWithoutSelection(element);
                  var insertingPosition = getCursorPosition(element);
                  var eneteredValue = String.fromCharCode(event.which);

                  var result = inputValue.substring(0, insertingPosition) + eneteredValue + inputValue.substring(insertingPosition, inputValue.length);
                  return angular.isNumber(scope.min) && parseFloat(result) < scope.min;
              }

              function getCursorPosition(element) {
                  var el = $(element).get(0);
                  var pos = 0;
                  if ('selectionStart' in el) {
                      pos = el.selectionStart;
                  } else if ('selection' in document) {
                      el.focus();
                      var Sel = document.selection ? document.selection.createRange() : window.getSelection();
                      var SelLength = Sel.text.length;
                      Sel.moveStart('character', -el.value.length);
                      pos = Sel.text.length - SelLength;
                  }
                  return pos;
              }

              function gettextWithoutSelection(element) {

                  var el = $(element).get(0);

                  if (document.selection) {

                      var elementSelection = document.selection.createRange();

                      if (elementSelection.text) {

                          var SelLength = elementSelection.text.length;
                          elementSelection.moveStart('character', -el.value.length);

                          return element.val().substring(elementSelection.text.length - SelLength, SelLength);
                      } 
                  } else {

                      if (window.getSelection().toString()) {
                          var originalValue = element.val();
                          var beforeSelection = originalValue.substring(0, el.selectionStart);
                          var afterSelection = originalValue.substring(el.selectionEnd, originalValue.length);
                          return beforeSelection + afterSelection;
                      }
                  }

                  return element.val();
              }

              scope.$watch('number', function (newNumberValue) {
                  scope.editingNumber = angular.copy(newNumberValue);
              });

              scope.$watch('editingNumber', function (newNumberValue) {
                  scope.number = newNumberValue;
              });
          }
      };
  }]);

angular.module('ntmApp')
  .directive('round', function () {
      return {
          require: 'ngModel',
          link: function ($scope, $element, $attrs, ngModelCtrl) {

              ngModelCtrl.$formatters.push(function (viewValue) {
                  return roundTo(viewValue);
              });

              function roundTo(text) {

                  if (!isNaN(text) && text !== null && !angular.isUndefined(text) && text !== '') {

                      if ($attrs.round) {
                          var number = parseFloat(text).toFixed($attrs.round);
                          return number;
                      }

                      return text;
                  }

                  return '';
              }
          }

      };
  });